<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/authorsnote">AUTHOR’S NOTE</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter_01">CHAPTER ONE: Lynda Ann Healy</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter_02">CHAPTER TWO: Georgann Hawkins</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_03" title="Link target outside of Sample">CHAPTER THREE: Kathy Parks</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_04" title="Link target outside of Sample">CHAPTER FOUR: Susan Rancourt</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_05" title="Link target outside of Sample">CHAPTER FIVE: The Lake Sammamish Reports #1</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_06" title="Link target outside of Sample">CHAPTER SIX: The Lake Sammamish Reports #2</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_07" title="Link target outside of Sample">CHAPTER SEVEN: King County Reports for Leon County</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_08" title="Link target outside of Sample">CHAPTER EIGHT: Seattle Reports and Articles</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_09" title="Link target outside of Sample">CHAPTER NINE: Don Patchen Reports and Investigative Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_10" title="Link target outside of Sample">CHAPTER TEN: Summary Report on the Chi Omega Murders</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_11" title="Link target outside of Sample">CHAPTER ELEVEN: Reports, Revelations, and Suspected Bundy Murders</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_12" title="Link target outside of Sample">CHAPTER TWELVE: Jerry Thompson Reports</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_13" title="Link target outside of Sample">CHAPTER THIRTEEN: Report on the Kimberly Diane Leach Murder</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_14" title="Link target outside of Sample">CHAPTER FOURTEEN: Bundy Florida Arrest Reports</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_15" title="Link target outside of Sample">CHAPTER FIFTEEN: A Letter from Bundy’s Roommate</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_16" title="Link target outside of Sample">CHAPTER SIXTEEN: Interviews and Testimonies of Other Witnesses</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_17" title="Link target outside of Sample">CHAPTER SEVENTEEN: Dr. Al Carlisle</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/photographs" title="Link target outside of Sample">PHOTOGRAPHS</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?192ffd0e